export const isProd: boolean = process.env.BUILD_ENV === 'prod';

export const isDevMode: boolean = process.env.NODE_ENV !== 'production';

export const CART_ID = 'cartId';
export const AGENT_NAME = 'wr_agent';
export const TRIP_VIEW_KEY = 'trip_view';
export const WAVEREZ_SITE = 'https://www.waverez.com';

export const DEFAULT_IMAGE_SIZES_BY_QUERIES = [
    { query: '(max-width: 500px)', size: '464x370' }, // mobile
    { query: '(max-width: 767px)', size: '730x569' }, // tablet
    { query: '(min-width: 767px)', size: '676x489' }, // desktop
];

export const CARDS_IMAGE_SIZES = [
    { query: '(max-width: 500px)', size: '454x242' }, // mobile
    { query: '(max-width: 767px)', size: '722x242' }, // tablet
    { query: '(min-width: 767px)', size: '496x274' }, // desktop
];

export const SEARCH_MAIN_IMAGE_SIZE = [
    { query: '(max-width: 500px)', size: '454x242' }, // mobile
    { query: '(max-width: 1023px)', size: '722x384' }, // tablet
    { query: '(min-width: 1024px)', size: '130x130' }, // desktop
];

export const SEARCH_IMAGE_SIZES = [
    { query: '(max-width: 500px)', size: '428x334' }, // mobile
    { query: '(min-width: 501px)', size: '722x384' }, // tablet
];

export const POPUP_OPENING_TIME_MINUTES = [1];

export const CRS_KEY = isProd
    ? 'kIAmSLetr63vs2OiFrLc6ovIbAHuCiP1yVkuEqte'
    : 'leyO34PGpH4g03tLoAX9K4L7fZZXZoAp2tOS5vDd';

export const LS_CONTACT_INFO = 'wr_contact-info';
export const LS_CRS_UTM = 'wr_crs_utm_data';
export const SESSION_PAYMENT = 'wr_session_response';
